module.exports = __webpack_public_path__ + "3deba3cd110fa53f7c2b1fe86ff9ce2c.woff";